import { render, staticRenderFns } from "./JbManCorretivaGrupo.vue?vue&type=template&id=1b770545&"
import script from "./JbManCorretivaGrupo.vue?vue&type=script&lang=js&"
export * from "./JbManCorretivaGrupo.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./JbManCorretivaGrupo.vue?vue&type=style&index=1&id=1b770545&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports